import { useState } from "react";
import { ArrowDownToLine, BarChart3, FileText, Receipt } from "lucide-react";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { FinancialOverview } from "@/components/accounting/FinancialOverview";
import { TransactionsTab } from "@/components/accounting/TransactionsTab";
import { ScheduleETab } from "@/components/accounting/ScheduleETab";
import { ExportTab } from "@/components/accounting/ExportTab";

const TAB_TRIGGER =
  "rounded-none border-b-2 border-transparent bg-transparent px-0 pb-3 pt-2.5 font-semibold text-muted-foreground gap-2 shadow-none data-[state=active]:border-primary data-[state=active]:bg-transparent data-[state=active]:text-primary data-[state=active]:shadow-none";

export default function Accounting() {
  const currentYear = new Date().getFullYear();
  const [year, setYear] = useState(currentYear);

  return (
    <div className="space-y-6">
      <div className="flex flex-wrap items-start justify-between gap-6">
        <div>
          <h1 className="text-3xl font-bold tracking-tight text-foreground">Accounting</h1>
          <p className="mt-1.5 max-w-3xl text-sm text-muted-foreground">
            Every financial event across your portfolio — rent, loans, rehab, taxes, insurance, depreciation —
            auto-mapped to IRS Schedule E. At tax time, just export.
          </p>
        </div>
        <Select value={String(year)} onValueChange={(v) => setYear(Number(v))}>
          <SelectTrigger className="w-[150px] font-semibold">
            <SelectValue />
          </SelectTrigger>
          <SelectContent>
            {Array.from({ length: 5 }, (_, i) => currentYear - i).map((y) => (
              <SelectItem key={y} value={String(y)}>
                {y} tax year
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      </div>

      <Tabs defaultValue="overview" className="space-y-5">
        <TabsList className="h-auto w-full justify-start gap-6 rounded-none border-b border-border bg-transparent p-0">
          <TabsTrigger value="overview" className={TAB_TRIGGER}>
            <BarChart3 className="h-4 w-4" /> Overview
          </TabsTrigger>
          <TabsTrigger value="transactions" className={TAB_TRIGGER}>
            <Receipt className="h-4 w-4" /> Transactions
          </TabsTrigger>
          <TabsTrigger value="schedule-e" className={TAB_TRIGGER}>
            <FileText className="h-4 w-4" /> Schedule E
          </TabsTrigger>
          <TabsTrigger value="export" className={TAB_TRIGGER}>
            <ArrowDownToLine className="h-4 w-4" /> Export
          </TabsTrigger>
        </TabsList>

        <TabsContent value="overview"><FinancialOverview year={year} /></TabsContent>
        <TabsContent value="transactions"><TransactionsTab year={year} /></TabsContent>
        <TabsContent value="schedule-e"><ScheduleETab year={year} /></TabsContent>
        <TabsContent value="export"><ExportTab year={year} /></TabsContent>
      </Tabs>
    </div>
  );
}
